<div class="floating-backdrop" *ngIf="isMenuOpen && !isOpen" (click)="closeMenu()"></div>

<div class="floating-hub" *ngIf="!isOpen" [class.is-expanded]="isMenuOpen">
  <div class="floating-hub__menu" *ngIf="isMenuOpen" role="menu" [attr.aria-label]="'CONSULT.FLOATING_TITLE' | translate">
    <a
      *ngIf="contact?.enable?.facebook"
      [href]="contact.facebook"
      target="_blank"
      rel="noopener noreferrer"
      class="floating-hub__item"
      role="menuitem"
      (click)="closeMenu()"
    >
      <span class="floating-hub__label">{{ contact.labels.facebook }}</span>
      <span class="floating-hub__icon-circle" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="#1877F2"
            d="M22 12a10 10 0 10-11.6 9.9v-7H7.8V12h2.6V9.8c0-2.6 1.5-4.1 4-4.1 1.2 0 2.4.2 2.4.2v2.6h-1.4c-1.4 0-1.8.9-1.8 1.8V12h3l-.5 2.9h-2.5v7A10 10 0 0022 12z"
          />
        </svg>
      </span>
    </a>

    <a
      *ngIf="contact?.enable?.zalo"
      [href]="contact.zalo"
      target="_blank"
      rel="noopener noreferrer"
      class="floating-hub__item"
      role="menuitem"
      (click)="closeMenu()"
    >
      <span class="floating-hub__label">{{ contact.labels.zalo }}</span>
      <span class="floating-hub__icon-circle" aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 48 48">
          <path
            fill="#008FE5"
            d="M24 4C12.95 4 4 11.61 4 21c0 4.72 2.35 8.97 6.14 12.02L8 44l10.2-5.3c1.9.5 3.88.77 5.8.77 11.05 0 20-7.61 20-17S35.05 4 24 4z"
          />
          <text x="24" y="27" text-anchor="middle" font-size="13" fill="#FFFFFF" font-weight="800" font-family="Inter, sans-serif">
            Zalo
          </text>
        </svg>
      </span>
    </a>

    <a
      *ngIf="contact?.enable?.phone"
      [href]="'tel:' + contact.phone"
      class="floating-hub__item"
      role="menuitem"
      (click)="closeMenu()"
    >
      <span class="floating-hub__label">{{ contact.labels.phone }}</span>
      <span class="floating-hub__icon-circle is-phone" aria-hidden="true">
        <svg width="19" height="19" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.3 1.2.4 2.6.6 4 .6.6 0 1 .4 1 1V21c0 .6-.4 1-1 1C10.3 22 2 13.7 2 3c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.4.2 2.8.6 4 .1.4 0 .8-.3 1.1l-2.2 2.7z"
          />
        </svg>
      </span>
    </a>

    <button
      type="button"
      class="floating-hub__item floating-hub__item--consult"
      role="menuitem"
      (click)="openForm()"
    >
      <span class="floating-hub__label">{{ 'CONSULT.FLOATING_TITLE' | translate }}</span>
      <span class="floating-hub__icon-circle is-consult" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 11H7v-2h10v2zm0-3H7V8h10v2z"
          />
        </svg>
      </span>
    </button>
  </div>

  <button
    type="button"
    class="floating-btn"
    [class.is-active]="isMenuOpen"
    (click)="toggleMenu()"
    [attr.aria-expanded]="isMenuOpen"
    [attr.aria-label]="(isMenuOpen ? 'CONSULT.CLOSE' : 'CONSULT.FLOATING_TITLE') | translate"
    [title]="'CONSULT.FLOATING_TITLE' | translate"
  >
    <svg *ngIf="!isMenuOpen" class="floating-btn__icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 5.92 2 10.75c0 2.73 1.44 5.17 3.7 6.77L4.5 22l4.87-2.44c.84.2 1.72.31 2.63.31 5.52 0 10-3.92 10-8.75S17.52 2 12 2zm-4 9.75c-.69 0-1.25-.56-1.25-1.25S7.31 9.25 8 9.25s1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm4 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm4 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"
      />
    </svg>
    <svg *ngIf="isMenuOpen" class="floating-btn__icon" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      />
    </svg>
  </button>
</div>

<div class="overlay" *ngIf="isOpen" (click)="closeForm()"></div>

<div class="popup-form" *ngIf="isOpen" role="dialog" aria-modal="true" aria-labelledby="form-title">
  <div class="popup-header">
    <h3 id="form-title">{{ 'CONSULT.HEADER' | translate }}</h3>
    <button type="button" class="close-btn" (click)="closeForm()" [attr.aria-label]="'CONSULT.CLOSE' | translate">✕</button>
  </div>

  <form [formGroup]="consultForm" (ngSubmit)="submitForm()">
    <div class="input-group">
      <input
        type="text"
        [placeholder]="'CONSULT.NAME_PLACEHOLDER' | translate"
        formControlName="fullName"
        [class.error-border]="consultForm.get('fullName')?.invalid && consultForm.get('fullName')?.touched"
      />
      <small class="error-text" *ngIf="consultForm.get('fullName')?.invalid && consultForm.get('fullName')?.touched">
        * {{ 'CONSULT.ERR_NAME' | translate }}
      </small>
    </div>

    <div class="input-group">
      <input
        type="text"
        [placeholder]="'CONSULT.PHONE_PLACEHOLDER' | translate"
        formControlName="phoneNumber"
        [class.error-border]="consultForm.get('phoneNumber')?.invalid && consultForm.get('phoneNumber')?.touched"
      />
      <small class="error-text" *ngIf="consultForm.get('phoneNumber')?.invalid && consultForm.get('phoneNumber')?.touched">
        * {{ 'CONSULT.ERR_PHONE' | translate }}
      </small>
    </div>

    <div class="input-group">
      <input
        type="email"
        [placeholder]="'CONSULT.EMAIL_PLACEHOLDER' | translate"
        formControlName="emailContact"
        [class.error-border]="consultForm.get('emailContact')?.invalid && consultForm.get('emailContact')?.touched"
      />
      <small class="error-text" *ngIf="consultForm.get('emailContact')?.invalid && consultForm.get('emailContact')?.touched">
        * {{ 'CONSULT.ERR_EMAIL' | translate }}
      </small>
    </div>

    <div class="input-group">
      <label class="input-label" for="consult-quantity">{{ 'CONSULT.QUANTITY_LABEL' | translate }}</label>
      <input
        id="consult-quantity"
        type="number"
        [placeholder]="'CONSULT.QUANTITY_PLACEHOLDER' | translate"
        formControlName="quantity"
      />
    </div>

    <div class="input-group">
      <textarea [placeholder]="'CONSULT.NOTE_PLACEHOLDER' | translate" formControlName="note"></textarea>
    </div>

    <button type="submit" class="submit-btn" [disabled]="consultForm.invalid || isSubmitting">
      {{ 'CONSULT.SUBMIT_BTN' | translate }}
    </button>
  </form>
</div>